import { TransformedLocaleConfig, LocaleName } from '../type';
const baseLocaleConfig = {
  name: 'te',
  months: [
    'జనవరి',
    'ఫిబ్రవరి',
    'మార్చి',
    'ఏప్రిల్',
    'మే',
    'జూన్',
    'జులై',
    'ఆగస్టు',
    'సెప్టెంబర్',
    'అక్టోబర్',
    'నవంబర్',
    'డిసెంబర్',
  ],
  monthsShort: ['జన', 'ఫిబ్ర', 'మార్చి', 'ఏప్రి', 'మే', 'జూన్', 'జులై', 'ఆగ', 'సెప్టెం', 'అక్టో', 'నవం', 'డిసెం'],
  weekdays: ['ఆదివారం', 'సోమవారం', 'మంగళవారం', 'బుధవారం', 'గురువారం', 'శుక్రవారం', 'శనివారం'],
  weekdaysMin: ['ఆ', 'సో', 'మ', 'బు', 'గు', 'శు', 'శ'],
  weekdaysShort: ['ఆది', 'సోమ', 'మంగళ', 'బుధ', 'గురు', 'శుక్ర', 'శని'],
  formats: {
    LT: 'HH:mm',
    LTS: 'HH:mm:ss',
    lt: 'h:mm A',
    lts: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    'LL-D': 'MMMM YYYY',
    'LL-Y': 'D MMMM',
    LLL: 'D MMMM YYYY HH:mm',
    'LLL-Y': 'D MMMM HH:mm',
    LLLL: 'dddd, D MMMM YYYY HH:mm',
    'LLLL-Y': 'dddd, D MMMM HH:mm',
    l: 'D/M/YYYY',
    'l-Y': 'D/M',
    ll: 'D MMM YYYY',
    'll-Y': 'D MMM',
    lll: 'D MMM YYYY h:mm A',
    'lll-Y': 'D MMM h:mm A',
    llll: 'ddd, D MMM YYYY h:mm A',
    'llll-Y': 'ddd, D MMM h:mm A',
    'll-Y+w': 'D MMM, ddd',
    'LT+to': 'HH:mm ([GMT]Z)',
    'LLL+to': 'D MMMM, YYYY HH:mm ([GMT]Z)',
  },
  meridiem: { am: 'am', pm: 'pm', AM: 'AM', PM: 'PM' },
  past: {
    y: { one: '%s సం. క్రితం', other: '%s సం. క్రితం' },
    M: { one: '%s నెల క్రితం', other: '%s నెలల క్రితం' },
    w: { one: '%s వారం క్రితం', other: '%s వారాల క్రితం' },
    d: { one: '%s రోజు క్రితం', other: '%s రోజుల క్రితం' },
    h: { one: '%s గం. క్రితం', other: '%s గం. క్రితం' },
    m: { one: '%s నిమి. క్రితం', other: '%s నిమి. క్రితం' },
    s: { one: '%s సెక. క్రితం', other: '%s సెక. క్రితం' },
  },
  future: {
    y: { one: '%s సం.లో', other: '%s సం.ల్లో' },
    M: { one: '%s నెలలో', other: '%s నెలల్లో' },
    w: { one: '%s వారంలో', other: '%s వారాల్లో' },
    d: { one: '%s రోజులో', other: '%s రోజుల్లో' },
    h: { one: '%s గం.లో', other: '%s గం.లో' },
    m: { one: '%s నిమి.లో', other: '%s నిమి.లో' },
    s: { one: '%s సెకనులో', other: '%s సెకన్లలో' },
  },
  abbr: {
    y: { one: '%sసం.', other: '%sసంవ.' },
    M: { one: '%sనెల', other: '%sనెలలు' },
    w: { one: '%sవారం', other: '%sవారాలు' },
    d: { one: '%sరోజు', other: '%sరోజులు' },
    h: { one: '%sగంట', other: '%sగంటలు' },
    m: { one: '%sనిమిషం', other: '%sనిమిషాలు' },
    s: { one: '%sసెకను', other: '%sసెకన్లు' },
  },
  justNow: 'ఇప్పుడే',
  yesterday: 'నిన్న',
  today: 'ఈరోజు',
  tomorrow: 'రేపు',
  weekStart: 0,
};
const localeName: LocaleName = 'te';
export const localeConfig: TransformedLocaleConfig = {
  ...baseLocaleConfig,
  name: localeName,
  meridiem: (hour, _, isLowerCase = false): string => {
    if (hour < 12) {
      return isLowerCase ? 'am' : 'AM';
    } else {
      return isLowerCase ? 'pm' : 'PM';
    }
  },
};
